module.exports = __webpack_public_path__ + "media/21.07d0cf2b.mp3";